import { createFileRoute } from "@tanstack/react-router";

import { GradePage } from "../../../workspaces/label/pages/GradePage";

export const Route = createFileRoute("/_console/label/qc/")({
  component: GradePage,
});
